export default "__VITE_ASSET__CT6wwxK9__"